import { render, staticRenderFns } from "./AppBarAfterSpacer.vue?vue&type=template&id=c19f5afe&"
import script from "./AppBarAfterSpacer.vue?vue&type=script&lang=js&"
export * from "./AppBarAfterSpacer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
import { VueAutoComplete }  from '@/components'
import { VueNotificationBar }  from '@/components'
installComponents(component, {VBadge,VBtn,VChip,VCol,VIcon,VList,VListItem,VListItemIcon,VListItemTitle,VMenu,VNavigationDrawer,VRow,VSpacer,VTooltip,VueAutoComplete,VueNotificationBar})


/* vuetify-loader */
import installIcons from "!../../../../node_modules/vuetify-loader/lib/runtime/installIcons.js"
import { mdiAccountSwitch } from '@mdi/js';
import { mdiBell } from '@mdi/js';
import { mdiBellOff } from '@mdi/js';
import { mdiDotsVertical } from '@mdi/js';
import { mdiLogoutVariant } from '@mdi/js';
installIcons(component, {mdiAccountSwitch,mdiBell,mdiBellOff,mdiDotsVertical,mdiLogoutVariant})
